module.exports = __webpack_public_path__ + "static/assets/74cec15256dfa9a0cf8e905ec9ef0fd2.png";